module.exports = __webpack_public_path__ + "static/media/endocrine-diseases-icon.819fbcc3.svg";